<template>
  <div style="position: relative" :id="`fileInput-${label}-div`">
    <!-- input -->
    <el-text-field
      v-if="!activeInput"
      readonly
      :label="translateLabel"
      :tooltip="tooltip"
      v-model="fileData.original_filename"
      class="file-input-text-field"
    >
      <template class="cutom-class" slot="append">
        <slot name="append">
          <v-hover close-delay="500" v-if="canDownload" v-slot="{ hover }">
            <el-button
              small
              class="file-input-btn mr-1"
              color="primary"
              :icon="hover ? '' : 'peržiūrėti'"
              :loading="loading"
              @click.native="download()"
              :disabled="disabled || readonly"
            >
              <div v-if="hover">
                {{ $t('Atsisiųsti') }}
              </div>
            </el-button>
          </v-hover>
          <v-hover close-delay="500" v-if="canReUpload" v-slot="{ hover }">
            <el-button
              class="file-input-btn"
              small
              :loading="loading"
              :disabled="disabled || readonly"
              color="secondary"
              @click.native="newUploadConfirm()"
              :icon="hover ? '' : 'atšaukti'"
            >
              <div v-if="hover">
                {{ $t('Pašalinti') }}
              </div>
            </el-button>
          </v-hover>
        </slot>
      </template>
    </el-text-field>
    <v-file-input
      v-if="activeInput"
      outlined
      dense
      :ref="`fileInput-${label}-ref`"
      prepend-icon=""
      background-color="white"
      persistent-placeholder
      :class="[compClass]"
      :style="getInputStyle()"
      :label="translateLabel"
      :disabled="disabled || !canUpload"
      :readonly="readonly"
      v-validate="validateRules"
      :data-vv-name="validateName"
      :error-messages="errorMessages"
      :data-vv-validate-on="required || counter ? 'input' : 'change'"
      :hide-details="hideDetails"
      v-model.trim="elValue"
      @blur="onBlur"
      @focus="onFocus"
      @change="changeFileInput($event)"
      @click:clear="clearFileInput($event)"
      :autofocus="autofocus"
    >
      <el-tooltip slot="append" v-if="tooltip" :tooltip="tooltip" absolute />
      <template class="cutom-class" slot="append">
        <slot name="append">
          <v-icon
            v-if="!activeInput"
            @click="clickAppend"
            style="cursor: pointer"
            :disabled="disabled || readonly"
          >
            mdi-paperclip
          </v-icon>
        </slot>
      </template>
    </v-file-input>
    <v-card
      v-if="activeInput"
      :ref="`dragInput-${label}-ref`"
      @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      @click.prevent="clickUpload"
      class="file-drop"
      :disabled="disabled || !canUpload"
    >
      <v-card-text style="padding: 8px">
        <v-row class="d-flex flex-column" dense align="center" justify="center">
          <v-icon color="primary" size="55"> mdi-cloud-upload </v-icon>
          <span :ref="`uploadText-${label}-ref`" :class="getUploadTextClass">{{ uploadText }} </span>
        </v-row>
        <div></div>
      </v-card-text>
    </v-card>
    <!-- modal -->
    <modal-delete
      title="Pašalinti dokumentą"
      text="Ar tikrai norite pašalinti dokumentą?"
      v-model="showDelete"
      :loading="loading"
      @confirmDelete="newUpload"
    />
  </div>
  
</template>

<script>
import math from '../../mixins/math'
import ModalDelete from '@/components/modals/ModalDelete'

export default {
  name: 'ElFileInput',
  components: {
    ModalDelete,
  },
  mixins: [math],
  props: {
    emitClearFile: Boolean,
    classP: String,
    label: String,
    placeholder: { type: String, default: ' ' },
    type: String,
    tooltip: String,
    counter: [Number, String],
    hideDetails: Boolean,
    required: Boolean,
    need: Boolean,
    date: Boolean,
    value: [File],
    disabled: Boolean,
    readonly: Boolean,
    autoGrow: { type: Boolean, default: true },
    appendOuterIcon: String,
    autofocus: { type: Boolean, default: false },
    fileData: Object,
    validateKey: String,
  },
  data() {
    return {
      loading: false,
      openUpload: false,
      showDelete: false,
      textHeight: null
    }
  },

  inject: {
    $validator: '$validator',
  },
  computed: {
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
    canDownload() {
      return true
    },
    canReUpload() {
      return true
    },
    canUpload() {
      return true
    },
    validateName() {
      return this.validateKey || this.label
    },
    activeInput() {
      return this.fileData ? (this.openUpload ? true : false) : true
    },
    sizeClass(){
      if(this.textHeight >= 82){
        return 'd-max-size'
      } else if (this.textHeight >= 62) {
        return 'd-mid-size'
      } else if (this.textHeight >= 41) {
        return 'd-min-size'
      } else {
        return ``
      }
    },

    uploadText() {
      return this.elValue
        ? this.elValue.name
        : this.$t('Paspauskite arba įtempkite rinkmeną')
    },
    translateLabel() {
      return this.$t(this.label)
    },

    validateMessages() {
      return {
        'field is required': this.$t('Laukas privalomas'),
      }
    },

    validateRules() {
      let rule = ''
      rule = this.required ? 'required' : ''
      return rule
    },

    errorMessages() {
      const messages = this.errors.collect(this.validateName)
      if (messages.length > 0) {
        const key = Object.keys(this.validateMessages).find((item) =>
          messages[0].includes(item)
        )
        return this.validateMessages[key]
      } else {
        return ''
      }
    },

    requiredClass() {
      return (this.required || this.need) && !this.readonly
        ? 'required-input'
        : ''
    },
    getUploadTextClass(){
      return `${this.sizeClass} d-upload-text-main`
    },
    compClass() {
      return `${this.sizeClass} ${this.classP} ${this.requiredClass} labelPatch ${
        this.activeInput ? 'file-input-active' : ''
      } `
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.getInputStyle()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', {});
  },
  methods: {
    onBlur(e) {
      this.$emit('blur', e.target.value)
    },

    onFocus(e) {
      this.$emit('focus', e.target.value)
    },

    clickAppend() {
      let ref = `fileInput-${this.label}-ref`
      this.$refs[ref].$refs.input.click()
    },

    clickUpload() {
      let ref = `dragInput-${this.label}-ref`
      this.$refs[ref].$el.blur()
      this.clickAppend()
    },

     updateParentHeight() {
        let ref = `uploadText-${this.label}-ref`
        const textElement = this.$refs[ref];
        if (textElement) {
          this.textHeight = textElement.offsetHeight; 
        }
     },

    getInputStyle(){
      this.updateParentHeight()
     },

    onDrop(e) {
      this.elValue = e.dataTransfer.files[0]
      this.$emit('addFile', e.dataTransfer.files[0])
    },

    changeFileInput(e) {
      this.$emit('addFile', e)
    },

    clearFileInput(e) {
      this.$emit('clearFile', e)
    },
    newUpload() {
      this.openUpload = true
      this.showDelete = false
      if (this.emitClearFile) {
        this.$emit('clearFile')
      }
    },
    newUploadConfirm() {
      this.showDelete = true
    },
    // file download
    download() {
      this.loading = true
      this.$axios
        .get(`uploads/${this.fileData.id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(this.fileData.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>

<style lang="scss" scoped></style>
